import AbstractModel from './AbstractModel';
import {IModelConfig} from '../../../@interfaces/services/Database/IModelConfig';
import {IReduxModelConfigsState} from '../../../@interfaces';
import {IListConfig} from '../../../@interfaces/components/List/IListConfig';
import {IFormConfig} from '../../../@interfaces/components/Form/IFormConfig';

export default class ModelConfig extends AbstractModel<IModelConfig> implements IModelConfig {
	readonly model!: string;
	readonly name!: string;
	readonly config!: IModelConfig['config'];

	async getStoredConfigs(): Promise<Pick<IReduxModelConfigsState, 'listConfigs' | 'formConfigs'>> {
		return this.table.toArray().then(items => {
			return items.reduce((res, item) => {
				if (item.name === 'list-config') {
					res.listConfigs[item.model] = item.config as IListConfig;
				} else if (item.name === 'form-config') {
					res.formConfigs[item.model] = item.config as IFormConfig;
				}

				return res;
			}, {
				listConfigs: {},
				formConfigs: {}
			} as Pick<IReduxModelConfigsState, 'listConfigs' | 'formConfigs'>);
		});
	}

	protected get table() {
		return this.connection.modelsConfigs;
	}
}
